import { render } from "./HomeServices.vue?vue&type=template&id=c3b65a7e"
import script from "./HomeServices.vue?vue&type=script&lang=js"
export * from "./HomeServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__